module.exports = __webpack_public_path__ + "img/card-bg1.b8ffb0e6.png";